import React, {useEffect} from 'react';

import {useSelector} from "react-redux";

import {TextField} from "../TextField/TextField";

import {getProfile} from "../../../../redux/reducers/user-profile-reducer";
import { UserRoles } from '../../../../utils/roles';

export const FullNameField = ({id, setFieldValue, AllgetFieldProps, name, value, content, sequenceNumber, format, onChange, supervisor, ...props}) => {
    const {user} = useSelector(getProfile)
    useEffect(() => {
        if (user && !value) {
            if (user.role === UserRoles.FIELD_CONTRACTOR) {
                if (supervisor) {
                   setFieldValue(name, {
                    value: supervisor.full_name, payload: {
                        [content?.firstNameVariable]: supervisor.first_name,
                        [content?.lastNameVariable]: supervisor.last_name,
                        [content?.emailVariable]: supervisor.email,
                        [content?.midNameVariable]: supervisor?.mid_name,
                        [content?.appointmentVariable]: supervisor.appointment,
                        [content?.phoneNumberVariable]: supervisor.phoneNumber,
                        [content?.organizationVariable]: supervisor.organization,
                        [content?.appointmentToWhomVariable]: supervisor.appointment_to_whom,
                        [content?.appointmentByWhomVariable]: supervisor.appointment_by_whom,
                        [content?.appointmentWhomVariable]: supervisor.appointment_whom,
                        [content?.fullNameToWhomVariable]: supervisor.full_name_to_whom,
                        [content?.fullNameByWhomVariable]: supervisor.full_name_by_whom,
                        [content?.fullNameWhomVariable]: supervisor.full_name_whom,
                        [content?.null]: supervisor.null,
                            }
                    }) 
                } 
            } else {
                setFieldValue(name, {
                    value: user.full_name, payload: {
                        [content?.firstNameVariable]: user.first_name,
                        [content?.lastNameVariable]: user.last_name,
                        [content?.emailVariable]: user.email,
                        [content?.midNameVariable]: user?.mid_name,
                        [content?.appointmentVariable]: user.appointment,
                        [content?.phoneNumberVariable]: user.phoneNumber,
                        [content?.organizationVariable]: user.organization,
                        [content?.appointmentToWhomVariable]: user.appointment_to_whom,
                        [content?.appointmentByWhomVariable]: user.appointment_by_whom,
                        [content?.appointmentWhomVariable]: user.appointment_whom,
                        [content?.fullNameToWhomVariable]: user.full_name_to_whom,
                        [content?.fullNameByWhomVariable]: user.full_name_by_whom,
                        [content?.fullNameWhomVariable]: user.full_name_whom,
                        [content?.null]: user.null,

                        }
                })
            }
            
        }
    }, [user, supervisor])

 

   
    return <TextField value={value?.value || ''}
                      inputProps={{readOnly: true}}
                      {...props}
    />
    
}


